__webpack_require__.p = "/data_react_tailwind/";